// KEY-MADE Version Tracking
// Update this when making significant changes
export const APP_VERSION = "1.6.2";
export const BUILD_DATE = "2025-02-25";
export const BUILD_NOTES = "Lead form improvements, As-Built/Design workflow complete with backend API";
